import { AddIcon } from '@chakra-ui/icons';
import { Alert, AlertDescription, AlertIcon, Button, Card, CardBody, CardHeader, Flex, Text } from '@chakra-ui/react';
import SearchBar from '@components/searchBar';
import { useSkuUpsertModal } from '@pages/UploadSellout/hooks/state/useSkuUpsertModal';
import { useFilter } from '@pages/UploadSellout/hooks/state/filters';
import Table from './table';

const DaftarProduk = () => {
    const { setFilter } = useFilter();
    const { openCreate } = useSkuUpsertModal();

    return (
        <>
            <Alert status="info" border="1px solid" borderColor="info.500" fontSize="14px">
                <AlertIcon />
                <AlertDescription>
                    Untuk product yang tidak berhasil termapping silahkan melakukan proses mapping pada fitur{' '}
                    <b>Upload &gt; Mapping</b>, lalu ulangi kembali proses smart upload.
                </AlertDescription>
            </Alert>
            <Card background="semantic.100">
                <CardHeader as={Flex} flexDirection="column" gap="24px">
                    <Text fontSize="20px" fontWeight="600">
                        Daftar Produk
                    </Text>
                    <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
                        <Flex alignItems="center" gap="16px">
                            <SearchBar
                                placeholder="Cari data sellout"
                                onChange={(e) => setFilter({ search: e.target.value, page: 1 })}
                            />
                        </Flex>
                        <Button
                            variant="outline"
                            borderColor="neutral.200"
                            color="semantic.900"
                            borderRadius="4px"
                            onClick={() => openCreate()}
                        >
                            <AddIcon />
                            Tambah SKU
                        </Button>
                    </Flex>
                </CardHeader>
                <CardBody paddingTop={0}>
                    <Table />
                </CardBody>
            </Card>
        </>
    );
};

export default DaftarProduk;
